<template>
  <div class="modal fade" id="modalOpenContact" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="title-modal">Editar contato realizado.</h4>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label>Contato com cliente:</label>
            <textarea v-if="dataCode.contactDone === false" class="form-control" id="contactText" rows="5"
                      v-model="dataCode.contactText">
            </textarea>
            <span v-if="errorContactText" class="error-msg">
            {{ errorContactText }}
          </span>
            <textarea v-if="dataCode.contactDone === true" class="form-control" id="contactText" rows="5"
                      v-model="dataCode.contactText" disabled>
            </textarea>
          </div>
        </div>

        <div class="modal-footer" filters>
          <button v-if="dataCode.contactDone === false" @click="registerContact()" :disabled="loadingChange"
                  v-bind:class="{'disable': loadingChange}" type="submit" class="btn btn-register">
            <span v-if="!loadingChange">Salvar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CANCELATION_CONTACT_DONE,
  CHANGE_NPS
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../utils";
import swal from "sweetalert";

export default {
  name: "modalOpenContact",
  props: ["dataCompanyModal"],
  data() {
    return {
      loadingChange: false,
      pageCancelation: false,
      dataCode: {
        contactText: "",
        contentSetting: "",
        companyId: "",
        id: "",
        contactDone: "",
        math: "",
      },
      errorContactText: "",
    };
  },
  watch: {
    dataCompanyModal: function (val) {
      console.log(val, 'val');
      this.dataCode.id = val.id;
      this.dataCode.contentSetting = val.context;
      this.dataCode.companyId = val.companyId;
      this.dataCode.contactDone = val.contactDone;
      this.dataCode.contactText = val.contactText;
      this.dataCode.math = val.math;
      val.pageCancelation ? this.pageCancelation = val.pageCancelation : "";
    },
  },

  methods: {
    closeModal() {
      $("#modalOpenContact").modal("toggle");
    },
    registerContact() {
      this.errorContactText = "";
      if (this.dataCode.contactText && this.dataCode.id) {
        this.loadingChange = true;
        let url = "";
        let obj = {}
        if (this.pageCancelation) {
          url = CANCELATION_CONTACT_DONE;
          obj.cancelationId = this.dataCode.id;
          obj.contactText = this.dataCode.contactText;
        } else {
          url = CHANGE_NPS;
          obj = this.dataCode;
        }
        UTIL_SERVICE.console("DATA SEND:", obj);
        REQUEST_SERVICE.requestContext(
          "POST",
          url,
          this.dataCode.contentSetting,
          obj
        )
          .then((response) => {
            UTIL_SERVICE.console(
              "RESULT CHANGE_CONTACT:",
              response.data
            );

            this.loadingChange = false;
            $("#modalOpenContact").modal("toggle");

            swal(
              "Aviso",
              "Contato atualizado com sucesso a seguir pressione F5 para Atualizar.",
              "success"
            );

          })
          .catch((reason) => {
            this.loadingChange = false;
            $("#modalOpenContact").modal("toggle");

            swal("Aviso", "Entre em contato com a equipe de DEV.", "error");
          });
      } else {
        this.errorContactText = "Preencha o campo de texto antes de continuar.";
      }
    },
  },
};
</script>

<style lang="scss">
#modalOpenContact {
  .owner-select {
    width: 100%;

    select {
      border: 1px solid #999;
      border-radius: 5px;
      height: 34px;
      width: 100%;
      padding: 0 10px;
      cursor: pointer;
    }
  }

  .error-msg {
    font-size: 12px;
    color: #E74A4E;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .form-control {
    max-width: 100%;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8B8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #FFF;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598DC;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #FFF;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalOpenContact.vue